import { render, staticRenderFns } from "./scoreBoard.vue?vue&type=template&id=5d294b87&scoped=true&"
import script from "./scoreBoard.vue?vue&type=script&lang=js&"
export * from "./scoreBoard.vue?vue&type=script&lang=js&"
import style0 from "./scoreBoard.vue?vue&type=style&index=0&id=5d294b87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d294b87",
  null
  
)

export default component.exports